import textWebAdmisi from '@/constants/text'

export default function text (key, vars = {}) {
  let value = textWebAdmisi[key]
  if (typeof value === undefined) {
    console.warn('text null', key)
    return ''
  }
  return value
}